export const chartTableCells: {
  name: string;
  align?: 'center' | 'right' | 'left' | 'justify' | 'inherit';
}[] = [
  { name: 'Title' },
  { name: 'Alias' },
  { name: 'Code' },
  { name: 'Currency', align: 'right' },
  { name: 'Units', align: 'right' }
];
